@use "../../../../styles/Constants.scss" as Constants;
@use "../../../../styles/Colors.scss" as Colors;

$filter-date-min-width: 150px;

$var-animationLength1: 300ms;

$button-radius: calc(#{Constants.$val-fieldSize} / 2);
$button-min-width: 80px;
$small-button-height: 26px;

$big-picker-width: 130px;
$small-picker-width: 80px;
$medium-picker-width: 100px;

.date-filter {
	margin-right: Constants.$val-spacing-s;
	display: flex;
	gap: Constants.$val-spacing-s;
}

.date-picker-wrapper {
	display: flex;
	flex-direction: row;
	border: 1px solid Colors.$col-design-grey14;
	height: Constants.$val-fieldSize;
	border-radius: Constants.$val-borderRadius;
	background-color: Colors.$col-white;

	&__big-picker {
		width: $big-picker-width;
	}

	&__small-picker {
		width: $small-picker-width;
	}

	&__medium-picker {
		width: $medium-picker-width;
	}
}

.date-picker-wrapper-fiscal {
	@extend .date-picker-wrapper;
	width: 100px;
	padding: 0 Constants.$val-spacing-s 0 Constants.$val-spacing-m;

	& :global(.dropdown-toggle) {
		padding: 0;
		width: 100%;
		min-width: 0;
	}

	& :global(.dropdown) {
		width: 100%;
	}
}

.date-picker-wrapper-monthly-year {
	width: 90px;
	padding: 0 Constants.$val-spacing-s;
	padding-left: Constants.$val-spacing-m;

	& :global(.dropdown-toggle) {
		padding: 0;
		width: 100%;
		min-width: 0;
	}

	& :global(.dropdown) {
		width: 100%;
	}
}

.date-picker-wrapper-monthly-month {
	width: 90px;
	padding: 0 Constants.$val-spacing-s 0 Constants.$val-spacing-m;
	position: relative;

	&::after {
		display: block;
		content: "";
		height: 12px;
		width: 1px;
		background-color: var(--col-grey-300);
		position: absolute;
		right: 0;
		top: 9px;
	}

	& :global(.dropdown-toggle) {
		padding: 0;
		width: 100%;
		min-width: 0;
	}

	& :global(.dropdown) {
		width: 100%;
	}
}

.background-color-animation {
	-webkit-transition: background-color $var-animationLength1 linear;
	-moz-transition: background-color $var-animationLength1 linear;
	-o-transition: background-color $var-animationLength1 linear;
	-ms-transition: background-color $var-animationLength1 linear;
	transition: background-color $var-animationLength1 linear;
}

.btn {
	@extend .background-color-animation;

	border-radius: $button-radius;
	height: Constants.$val-fieldSize;
	min-width: $button-min-width;
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: center;

	& [class^="icon-"] {
		font-size: Constants.$val-fontSizeBig;
		margin-right: Constants.$val-spacing-s;
	}

	& + & {
		margin-left: Constants.$val-spacing-s;
	}

	&--icon {
		min-width: Constants.$val-fieldSize;
		width: Constants.$val-fieldSize;
		padding: 0;
		overflow: hidden;

		& [class^="icon-"] {
			margin-right: 0;
		}

		&.btn--small {
			height: $small-button-height;
			width: $small-button-height;
			min-width: $small-button-height;
		}
	}

	&--filter {
		border-radius: Constants.$val-borderRadius;
		border: 1px solid Colors.$col-greyMid;
		background: Colors.$col-white;

		.btn {
			padding: 0;
			min-width: auto;
			display: flex;
			justify-content: center;
		}

		&.btn--icon {
			background: Colors.$col-greyBackground;
		}
	}

	&--filter-right {
		border-left: none;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	&--filter-left {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}

	&--filter-middle {
		border-radius: 0;
		border-left: none;
	}
}

.date-period {
	background-color: Colors.$col-white;
	border: 1px solid Colors.$col-greyMid;
	border-radius: Constants.$val-borderRadius !important;
	height: Constants.$val-fieldSize;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	& :global(.dropdown-toggle) {
		padding: 0 4px 0 8px;
	}

	& :global(.dropdown-item) {
		// Matching the width of parent dropdown, which also has fixed width
		min-width: 142px;
	}

	& :global(.dropdown-menu__selected) {
		min-width: 120px;
		display: flex;
		align-items: center;
	}
}

.picker {
	border: 0px;
	border-radius: Constants.$val-borderRadius;
	height: Constants.$val-fieldSize - 3px !important;
	width: inherit;
	padding-left: Constants.$val-spacing-m;
}

.calendar-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	background: Colors.$col-white;
	font-size: Constants.$val-fontSizeBig;
	padding: Constants.$val-spacing-s;
	width: auto;
	z-index: 10;
	border-radius: Constants.$val-borderRadius;
}

.date-picker-dash {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	font-size: Constants.$val-fontSizeBig;
	margin-right: Constants.$val-spacing-s;
	z-index: 1000;
}

.selected-fiscal-year {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 30px;

	& :global(.icon-calendar) {
		margin: 0;
	}
}
